import { Injectable } from '@angular/core';
import { IToast, ToastType } from '@barthauer/custom/xmt-models';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private toastSubject: Subject<IToast> = new Subject();
  public toast$: Observable<IToast> = this.toastSubject.asObservable();

  /**
   * Sends a toast message to be displayed in the UI.
   *
   * @param message The content of the toast message.
   * @param type The type of the toast (e.g., success, error, info).
   * @param displayTime Optional. The duration in milliseconds that the toast should be displayed.
   *                    If not provided, a default display time may be used by the subscriber.
   */
  public toast(message: string, type: ToastType, displayTime?: number): void {
    this.toastSubject.next({
      message: message,
      type: type,
      displayTime: displayTime,
    });
  }
}
